﻿import { Box, Paper, Tooltip } from '@mui/material';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { useEffect, useState } from 'react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUICustomDataGrid } from '../../../../atomic/molecules';
import Swal from 'sweetalert2';
import TimeHelper from '../../../../utils/time';
import { CustomerQuery } from '../../../../services/query';
import { SCUILoadingLinear } from '../../../../atomic/atoms';
import { GCDD } from './getCustomerDeviceDetails.classes';

interface IProps {
    data?: any;
}
export const GetCustomerDeviceDetails: FC<IProps> = ({ data }) => {
    const { t } = useTranslation();
    const [customerDeviceDetail, setCustomerDeviceDetail] = useState<any>();
    const [loading, setLoading] = useState(false);
    const columns: ExtendedGridColDef[] = [
        {
            field: 'platform',
            headerName: t('customerInformation.operatingSystem'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            maxWidth: 120,
            renderCell: (params: any) => {
                return <p>{params.row.platform}</p>;
            },
        },
        {
            field: 'deviceBrand',
            headerName: t('general.brand'),
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            minWidth: 120,
            renderCell: (params: any) => {
                return (
                    <Tooltip title={params.row.deviceBrand}>
                        <p>{params.row.deviceBrand}</p>
                    </Tooltip>
                );
            },
        },
        {
            field: 'deviceModel',
            headerName: t('customerInformation.model'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <Tooltip title={params.row.deviceModel}>
                        <p>{params.row.deviceModel}</p>
                    </Tooltip>
                );
            },
        },
        {
            field: 'versionCode',
            headerName: t('customerInformation.latestVersion'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'lastActionIP',
            headerName: t('customerInformation.lastActionIP'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <Tooltip title={params.row.lastActionIP}>
                        <p>{params.row.lastActionIP}</p>
                    </Tooltip>
                );
            },
        },
        {
            field: 'osVersion',
            headerName: t('customerInformation.operatingSystemVersion'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <Tooltip title={params.row.osVersion}>
                        <p>{params.row.osVersion}</p>
                    </Tooltip>
                );
            },
        },
        {
            field: 'userAgent',
            headerName: t('customerInformation.userAgent'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                return (
                    <Tooltip title={params.row.userAgent}>
                        <p>{params.row.userAgent}</p>
                    </Tooltip>
                );
            },
        },
        {
            field: 'createDate',
            headerName: t('commentDetail.createdDate'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'updateDate',
            headerName: t('commentDetail.updatedDate'),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
        },
    ];
    const GetCustomerDeviceDetails = async () => {
        setLoading(true);
        let params = {
            CustomerId: data.customer.customerId,
        };
        CustomerQuery.GetCustomerDeviceDetails(params)
            .then((res: any) => {
                if (res.data) {
                    console.info(res.data);
                    let parseData = res.data.customerDeviceDetails.map((item: any) => {
                        return {
                            platform: item.platform,
                            deviceBrand: item.deviceBrand !== null ? item.deviceBrand : '-',
                            deviceModel: item.deviceModel || '-',
                            versionCode: item.versionCode || '-',
                            lastActionIP: item.lastActionIP !== null ? item.lastActionIP : '-',
                            createDate: (item.createDate && TimeHelper.formatDateHour(item.createDate)) || '-',
                            updateDate: (item.updateDate && TimeHelper.formatDateHour(item.updateDate)) || '-',
                            osVersion: item.osVersion || '-',
                            userAgent: item.userAgent || '-',
                        };
                    });
                    setCustomerDeviceDetail(parseData);
                } else {
                    setCustomerDeviceDetail([]);
                }
            })
            .catch((error: any) => {
                Swal.fire(t('general.error'), ' ', 'error');
                console.log('Hata :>> ', error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        GetCustomerDeviceDetails();
    }, []);

    return (
        <Paper
            className={GCDD.page}
            style={{
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '16px',
            }}
        >
            <SCUILoadingLinear display={loading} />
            {customerDeviceDetail && (
                <Box className={GCDD.datagrid}>
                    <SCUICustomDataGrid
                        randomId
                        columns={columns}
                        rows={customerDeviceDetail}
                        localeText={t('customerInformation.localeText')}
                    />
                </Box>
            )}
        </Paper>
    );
};

